export const AnnouncementBanner = () => {
  return (
    <div className="w-full bg-gradient-to-r from-primary-900 to-primary-800 border border-primary-300 text-secondary-300">
      <p className="text-center font-inter text-lg py-2 px-4">Eastleigh is now live!</p>
    </div>
  )
}
